export class PixiApplicationCommon {
    constructor() {
        this.drawingZone = { width: 18, height: 18 };
        this.offset = { width: 6, height: 6 };
    }
    relativePositionToAbsolutePosition(entityRelativePosition, resolution) {
        const scaleRatio = this.retrieveScaleRatio(resolution);
        return {
            x: entityRelativePosition.x * scaleRatio.width + this.offset.width * scaleRatio.width,
            y: entityRelativePosition.y * scaleRatio.height + this.offset.height * scaleRatio.height
        };
    }
    absolutePositionToRelativePosition(entityRelativePosition, resolution) {
        const scaleRatio = this.retrieveScaleRatio(resolution);
        const relativePosition = {
            width: entityRelativePosition.x / scaleRatio.width - this.offset.width / scaleRatio.width,
            height: entityRelativePosition.y / scaleRatio.height - this.offset.height / scaleRatio.height
        };
        return relativePosition;
    }
    retrieveScaleRatio(resolution) {
        return {
            width: resolution.width / this.drawingZone.width,
            height: resolution.height / this.drawingZone.height
        };
    }
}
